export const checkIfNumber = (value) => {
  if (value === undefined || value === null || value === '-' || value === '') return false;
  return !isNaN(Number(value));
};

/**
 * Calculate the max number of rows needed for the day
 */
export const getMaxRowCounts = (count: {
  ingredients: number;
  dishes: number;
  additionCharges: number;
  afternoons: number;
}) => {
  const counts = [count.ingredients, count.dishes, count.additionCharges, count.afternoons];

  return Math.max(1, ...counts);
};
